// extracted by mini-css-extract-plugin
export default {"modalOverlay":"modalOverlay__S07Hm","modalContent":"modalContent__q+dpa","headerTitle":"headerTitle__hICkV","close":"close__RmJKI"};